import React from 'react';
import { compose, withHandlers } from 'recompose';
import '../../../../components/sharedStyle.scss';
import ChatbotModel from '@mm/state/model/ChatbotModel';
import SettingSection from '../../../../components/SettingSection/SettingSection';
import PrimarySelect from '../../../../../../../common/components/PrimarySelect/PrimarySelect';

type OuterProps = {
  languages: string[];
  updateChatbot: (bot: Partial<ChatbotModel>) => any;
  chatbot: ChatbotModel;
};

type Handlers = {
  onLanguageChange: (value: string) => void;
};

type InnerProps = Handlers;

type Props = OuterProps & InnerProps;

const Language = (props: Props) => {
  const { chatbot: activeBot, onLanguageChange, languages } = props;

  const selectedLanguage = activeBot ? activeBot.language : undefined;

  const options = languages.map(id => ({ id, name: id, key: id }));
  const value = options.find(({ id }) => id === selectedLanguage);

  return (
    <SettingSection title="Language">
      <PrimarySelect
        value={value}
        placeholder="Select language"
        options={options}
        onChange={({ id }) => onLanguageChange(String(id))}
      />
    </SettingSection>
  );
};

const onLanguageChange = (props: Props) => (value: string) => {
  const { chatbot: activeBot } = props;

  if (activeBot) {
    props.updateChatbot({
      ...activeBot,
      language: value,
    });
  }
};

const enhance = compose<InnerProps, OuterProps>(
  withHandlers({ onLanguageChange }),
);

export default enhance(Language);
